import {ParsedUrlQuery} from 'querystring'

const hiddenKeys = ['hostname', 'viewport']
export default function queryObjectToString(query: ParsedUrlQuery) {
  return Object.keys(query)
    .filter(key => !hiddenKeys.includes(key))
    .map(key => `${key}=${query[key]}`)
    .join('&')
}
